import { render, staticRenderFns } from "./change-fontsize.vue?vue&type=template&id=fe6f911a&scoped=true&"
import script from "./change-fontsize.vue?vue&type=script&lang=js&"
export * from "./change-fontsize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6f911a",
  null
  
)

export default component.exports